import { Cesium3DTileset, Matrix4, Cesium3DTileStyle } from 'cesium';

export default class TilesBuilding {
    constructor(options) {
        const url =
            options.url ||
            `http://183.129.170.220:10301/geoserver/www/laiyang/jianzhu/tileset.json`;
        this.viewer = options.viewer;
        this.tiles = this.load(url);

        this.show = options.show || true;

        if (options.visibleHeight) {
            this.setVisibleByHeight(options.visibleHeight);
        }

        if (options.style) {
            this.render(options.style);
        }
    }

    set show(val) {
        this.tiles.show = val;
    }

    load(url) {
        const viewer = this.viewer;
        return viewer.scene.primitives.add(
            new Cesium3DTileset({
                url,
                modelMatrix: Matrix4.fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
                maximumMemoryUsage: 100, //不可设置太高，目标机子空闲内存值以内，防止浏览器过于卡
                maximumScreenSpaceError: 16, //用于驱动细节细化级别的最大屏幕空间错误;较高的值可提供更好的性能，但视觉质量较低。
                preferLeaves: true,
                shadows: false, //是否显示阴影
                skipLevelOfDetail: true,
                baseScreenSpaceError: 1024,
                skipScreenSpaceErrorFactor: 16,
                skipLevels: 1,
                immediatelyLoadDesiredLevelOfDetail: false,
                loadSiblings: false,
                cullWithChildrenBounds: true,
                dynamicScreenSpaceError: true,
                dynamicScreenSpaceErrorDensity: 0.00278,
                dynamicScreenSpaceErrorFactor: 4.0,
                dynamicScreenSpaceErrorHeightFalloff: 0.25,
            }),
        );
    }

    setVisibleByHeight(height) {
        const _this = this;
        const { viewer } = this;
        viewer.build3DTilesVisible = function() {
            // 当前高度
            let currentHeight = viewer.camera.positionCartographic.height;

            _this.show = currentHeight <= height;
        };
    }

    render(type, color) {
        this.tiles.style = null;

        if (type === 'blue') {
            this.renderBlueBuild();
        } else if (type === 'type') {
            // this.clearBlueBuildStyle();
            this.renderType();
        } else if (type === 'height') {
            this.clearBlueBuildStyle();
            this.renderHeight();
        } else {
            this.clearBlueBuildStyle();
            this.renderCustom(color);
        }
    }

    clearBlueBuildStyle() {
        this.tiles.readyPromise.then(function(tiles) {
            tiles.tileVisible.addEventListener(tile => {
                let content = tile.content;
                let featuresLength = content.featuresLength;
                for (let i = 0; i < featuresLength; i += 2) {
                    let feature = content.getFeature(i);

                    let model = feature.content._model;

                    if (model && model._sourcePrograms && model._rendererResources) {
                        Object.keys(model._sourcePrograms).forEach(key => {
                            let program = model._sourcePrograms[key];
                            let fragmentShader =
                                model._rendererResources.sourceShaders[program.fragmentShader];
                            let v_position = '';
                            if (fragmentShader.indexOf(' v_positionEC;') !== -1) {
                                v_position = 'v_positionEC';
                            } else if (fragmentShader.indexOf(' v_pos;') !== -1) {
                                v_position = 'v_pos';
                            }
                            const color = `vec4(${feature.color.toString()})`;
                            model._rendererResources.sourceShaders[
                                program.fragmentShader
                            ] = `varying vec3 ${v_position};
                   void main(void) {
                    vec4 position = czm_inverseModelView * vec4(${v_position}, 1);
                    gl_FragColor = ${color};
                    gl_FragColor *= vec4(vec3(position.y / 120.0), 3);
                  }`;
                        });
                        model._shouldRegenerateShaders = true;
                    }
                }
            });
        });
    }

    renderBlueBuild() {
        this.tiles.readyPromise.then(function(tiles) {
            tiles.tileVisible.addEventListener(tile => {
                let content = tile.content;
                let featuresLength = content.featuresLength;
                for (let i = 0; i < featuresLength; i += 2) {
                    let feature = content.getFeature(i);

                    let model = feature.content._model;

                    if (model && model._sourcePrograms && model._rendererResources) {
                        Object.keys(model._sourcePrograms).forEach(key => {
                            let program = model._sourcePrograms[key];
                            let fragmentShader =
                                model._rendererResources.sourceShaders[program.fragmentShader];
                            let v_position = '';
                            if (fragmentShader.indexOf(' v_positionEC;') !== -1) {
                                v_position = 'v_positionEC';
                            } else if (fragmentShader.indexOf(' v_pos;') !== -1) {
                                v_position = 'v_pos';
                            }
                            const color = `vec4(${feature.color.toString()})`;
                            model._rendererResources.sourceShaders[
                                program.fragmentShader
                            ] = `varying vec3 ${v_position};
                   void main(void) {
                    vec4 position = czm_inverseModelView * vec4(${v_position}, 1);
                    float glowRange = 360.0;
                    gl_FragColor = ${color};
                    gl_FragColor = vec4(0.2, 0.8, 1.0, 0.5);
                    gl_FragColor *= vec4(vec3(position.y / 140.0), 3);
                  }`;
                        });
                        model._shouldRegenerateShaders = true;
                    }
                }
            });
        });
    }

    renderType() {
        this.tiles.readyPromise.then(function(tiles) {
            tiles.tileVisible.addEventListener(tile => {
                let content = tile.content;
                let featuresLength = content.featuresLength;
                for (let i = 0; i < featuresLength; i += 2) {
                    let feature = content.getFeature(i);

                    let model = feature.content._model;

                    if (model && model._sourcePrograms && model._rendererResources) {
                        Object.keys(model._sourcePrograms).forEach(key => {
                            let program = model._sourcePrograms[key];
                            let fragmentShader =
                                model._rendererResources.sourceShaders[program.fragmentShader];
                            let v_position = '';
                            if (fragmentShader.indexOf(' v_positionEC;') !== -1) {
                                v_position = 'v_positionEC';
                            } else if (fragmentShader.indexOf(' v_pos;') !== -1) {
                                v_position = 'v_pos';
                            }
                            const color = `vec4(${feature.color.toString()})`;
                            model._rendererResources.sourceShaders[
                                program.fragmentShader
                            ] = `varying vec3 ${v_position};
                   void main(void) {
                    vec4 position = czm_inverseModelView * vec4(${v_position}, 1);
                    gl_FragColor = ${color};
                    gl_FragColor = vec4(0.25, 0.69, 0.56, 1);
                    gl_FragColor *= vec4(vec3(position.y / 150.0), 3);
                  }`;
                        });
                        model._shouldRegenerateShaders = true;
                    }
                }
            });
        });
    }

    renderHeight() {
        this.tiles.style = new Cesium3DTileStyle({
            color: {
                conditions: [
                    ['${height} < 20', 'rgb(255, 237, 160)'],
                    ['${height} >= 25 && ${height} < 30', 'rgb(254, 217, 118)'],
                    ['${height} >= 30 && ${height} < 35', 'rgb(254, 178, 76)'],
                    ['${height} >= 35 && ${height} < 40', 'rgb(253, 141, 60)'],
                    ['${height} >= 40', 'rgb(252, 78, 42)'],
                ],
            },
        });
    }

    renderCustom(color) {
        if (color) {
            this.tiles.style = new Cesium3DTileStyle({
                color: {
                    conditions: [['${height} > 0', `color("${color}")`]],
                },
            });
        }
    }
}
